import type * as mapboxgl from "mapbox-gl";

import { loadMapIcons } from "~/modules/map/util/imageLoaders";

import { MAP_SHAPE_ICONS } from "./mapShapeIcons";

const MAP_SHAPE_ICON_SIZE = 40;

export async function loadMapShapeIcons(map: mapboxgl.Map): Promise<void> {
    await loadMapIcons(map, MAP_SHAPE_ICONS, MAP_SHAPE_ICON_SIZE);
}
